import { API_URL } from '@api/apiDictionary';
import { RESTClient } from '@api/client';
import { Workflow } from '@restore/workflows/workflows.types';

export const fetchWorkflowList = () => {
  return RESTClient.get<Workflow[]>(API_URL.utilsWorkflows);
};
export const createWorkflow = (workflow: Workflow) => {
  return RESTClient.post(API_URL.utilsWorkflows, workflow);
};
